import { render } from "./RegistroView.vue?vue&type=template&id=4c15952b"
import script from "./RegistroView.vue?vue&type=script&lang=js"
export * from "./RegistroView.vue?vue&type=script&lang=js"

import "./RegistroView.vue?vue&type=style&index=0&id=4c15952b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__